module.exports = __webpack_public_path__ + "img/freeze-purple.aa19bc11.svg";